import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  GetCardDetails,
  GetInvoiceList,
  GetPaymentHistory,
} from "../../StateManagement/Reducers/BillingState";
import { GetRefundHistory } from "../../StateManagement/Reducers/RefundState";

import TopNav from "../TopNav";
import MyCards from "./MyCards";
import InvoiceList from "./InvoiceList";
import Loading from "../StyledComponents/Loading";

import { BodyContainer } from "../StyledComponents";
import { Div } from "./Styles";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";

const Billing = () => {
  const dispatch = useDispatch();

  const CardLoading = useSelector((state) => state.Billing.CardLoading);
  const InvoiceLoading = useSelector((state) => state.Billing.InvoiceLoading);
  let accountType =
    localStorage.getItem("account_type") &&
    Decrypt_Value(localStorage.getItem("account_type"), "vozoportal");

  useEffect(() => {
    dispatch(GetCardDetails());
    dispatch(GetInvoiceList());
    dispatch(GetPaymentHistory());
    dispatch(GetRefundHistory());
  }, [dispatch]);

  return (
    <>
      <TopNav title="Billing" />
      {CardLoading && InvoiceLoading ? (
        <>
          <Loading />
        </>
      ) : (
        <BodyContainer
          paddingLeft="40px"
          paddingTop="32px"
          background="#f8fafc"
        >
          {accountType !== -1 && (
            <Div marginBottom="48px" background="transparent">
              <MyCards />
            </Div>
          )}
          <Div background="transparent">
            <InvoiceList />
          </Div>
        </BodyContainer>
      )}
    </>
  );
};

export default Billing;
